export default {"src":"/_next/static/media/print-grey.ea4718c1.svg","height":17,"width":17};